import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PriceUIHelper";
const PriceUIContext = createContext();

export function usePriceUIContext() {
  return useContext(PriceUIContext);
}

export const PriceUIConsumer = PriceUIContext.Consumer;

export function PriceUIProvider({ priceUIEvents, children }) {
  // initial filter
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const [ids, setIds] = useState([]);

  const value = {
    ids,
    setIds,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newPriceButtonClick: priceUIEvents.newPriceButtonClick,
    openEditPricePage: priceUIEvents.openEditPricePage,
    openDeletePriceDialog: priceUIEvents.openDeletePriceDialog,
  };
  return (
    <PriceUIContext.Provider value={value}>{children}</PriceUIContext.Provider>
  );
}
